import { useState } from "react";
import { useTimeLimit } from "./TimeLimitProvider";
import { PinPad } from "./PinPad";
import { useT } from "../i18n/LocaleProvider";

/** Shown (while staying in fullscreen) when the child double-presses Escape.
 *  The grown-up enters the code to actually leave; "Keep drawing" stays put. */
export function ExitCodePrompt({ onCancel }: { onCancel: () => void }) {
  const t = useT();
  const { hasPin, verifyPin, setFsLock, registerPinAttempt, pinHint } = useTimeLimit();
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="lock-overlay" role="dialog" aria-modal="true" aria-label={t.exitAria}>
      <div className="lock-card">
        <div className="lock-emoji" aria-hidden="true">
          🔒
        </div>
        <h2>{t.exitTitle}</h2>
        {hasPin ? (
          <>
            <p>{t.exitBody}</p>
            <PinPad
              onComplete={(code) => {
                const ok = verifyPin(code);
                registerPinAttempt(ok);
                if (ok) setFsLock(false);
                else setError(t.lockWrongCode);
              }}
              error={error}
              hint={pinHint}
            />
          </>
        ) : (
          <button className="pill-btn lock-unlock" onClick={() => setFsLock(false)}>
            {t.exitBtn}
          </button>
        )}
        <button className="tl-action" onClick={onCancel}>
          {t.exitKeepDrawing}
        </button>
      </div>
    </div>
  );
}
